import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { BudgetFundingSourceAudit } from '@core/typings/budget.typing';
import { ClientSettingsService } from '@features/client-settings/client-settings.service';
import { DebounceFactory, TableDownloadDetails, TableDownloadFactory, TopLevelFilter } from '@yourcause/common';
import { I18nService } from '@yourcause/common/i18n';
import { Subscription } from 'rxjs';
import { BudgetService } from '../budget.service';
import { TableDataDownloadFormat } from '@yourcause/common/files';

@Component({
    selector: 'gc-budget-audit-trail-table',
    templateUrl: './budget-audit-trail-table.component.html',
    styleUrls: ['./budget-audit-trail-table.component.scss'],
    standalone: false
})
export class BudgetAuditTrailTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() budgetId: number;
  @Input() isSimple = false;

  tableKey: string;
  hideFundingSources = this.clientSettingsService.hideFundingSources;
  tableDownloadFactory: TableDownloadFactory<BudgetFundingSourceAudit>;
  topLevelFilters: TopLevelFilter[] = [];
  rows: BudgetFundingSourceAudit[] = [];
  sub = new Subscription();
  isAfterInit = false;

  constructor (
    private budgetService: BudgetService,
    private i18n: I18nService,
    private clientSettingsService: ClientSettingsService
  ) {
    this.sub.add(this.budgetService.changesTo$('budgetDetailMap').subscribe(() => {
      this.setTableKeyAndRows();
    }));
  }

  ngOnInit () {
    this.setTableKeyAndRows();
    if (!this.isSimple) {
      this.topLevelFilters = [
        new TopLevelFilter(
          'text',
          'createdByUserName',
          '',
          this.i18n.translate(
            this.hideFundingSources ?
              'GLOBAL:textSearchByUser' :
              'GLOBAL:textSearchByUserOrFundingSource',
            {},
            this.hideFundingSources ?
              'Search by user' :
              'Search by user or funding source'
          ),
          undefined,
          undefined,
          this.hideFundingSources ? undefined : [{
            column: 'createdByUserName',
            filterType: 'cn'
          }, {
            column: 'fundingSourceName',
            filterType: 'cn'
          }]
        )
      ];
    }
    this.tableDownloadFactory = DebounceFactory.createSimple(
      async (details: TableDownloadDetails<BudgetFundingSourceAudit>) => {
        await this.downloadTable(details.format);
      },
      0
    );
    this.isAfterInit = true;
  }

  ngOnChanges () {
    if (this.isAfterInit) {
      this.setTableKeyAndRows();
    }
  }

  async downloadTable (
    format: TableDataDownloadFormat
  ) {
    await this.budgetService.downloadBudgetAuditTrail(this.budgetId, format);
  }

  setTableKeyAndRows () {
    this.tableKey = this.budgetService.getTableKeyForAuditTrail(this.budgetId, this.isSimple);
    this.rows = this.budgetService.getBudgetAuditTrailFromMap(this.budgetId);
  }

  ngOnDestroy () {
    this.sub.unsubscribe();
  }
}
